import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useMemo } from "react";
import "../style.css";
import {BaseChart} from "./BaseChart";
import millify from "millify";

interface DoughnutChartProps {
    data: any;
    dataSets: any;
    labels: any;
    title?: string;
    isDataLoaded: boolean;
    totalLabel?: string;
    cutout: number;
    totalValue?: string
}

export const DoughnutChart = ({ data, dataSets, labels, title = "", isDataLoaded = false, totalLabel = "", cutout = 110, totalValue = undefined }: DoughnutChartProps) => {
    ChartJS.register(ArcElement, Tooltip, Legend);

    const digestedData = useMemo(() => {
        if(data && isDataLoaded) {
            return {
                labels,
                datasets: dataSets.map((dataSet: any) => {
                    return {
                        label: dataSet.label,
                        data: dataSet.values,
                        backgroundColor: dataSet.backgroundColor,
                    };
                })
            };
        } else return {
            labels: [],
            datasets: [],
        };
    }, [data, isDataLoaded]);

    const total = useMemo(() => {
        if(totalValue) return totalValue;
        return millify(dataSets[0]?.values?.reduce((accumulator: number, currentValue: string) => {
            return accumulator + parseInt(currentValue)
        },0));
    }, [totalValue, dataSets[0].values]);

    return <div className="doughnut-container">
        {totalLabel && isDataLoaded ? <div className="doughnut-sum">{total}<span>{totalLabel}</span></div> : null}
        <div className="chart">
            <BaseChart
                data={digestedData}
                title={title}
                Chart={Doughnut}
                options={{
                    plugins: {
                        legend: {
                            display: false,
                        }
                    },
                    cutout,
                }}
                isDataLoaded={isDataLoaded}
            />
        </div>
    </div>
}